import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import { useTableColumnsFlotas } from "@/erp/mantenimiento-operacion/flotas/shared/hooks";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { getPlanificadores, useFetchFlotas } from "@/shared/actions/erp";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { Flota } from "@/shared/interfaces/erp/mantenimiento-operaciones";
import { usePlanificadorStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { Visibility } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";

export type FlotasPageProps = {};

const PlanificadoresPageView: React.FC<FlotasPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_planificador);

  const returnUrlPlanificadoresPage = ROUTER_PATHS.operaciones.flotasViewNav;

  const navigate = useNavigate();

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const setSelectedFlota = usePlanificadorStore((s) => s.setSelectedFlota);

  ///* global state -----------------------
  const setAlert = useUiStore((s) => s.setAlert);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  ///* table -----------------------
  const { pagination, searchTerm, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: flotasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchFlotas({
    page: pageIndex + 1,
    page_size: pageSize,
    nombre: searchTerm,
    ...filterObject,
    estado: true,
  });

  ///* handlers
  const onView = async (original: Flota) => {
    setIsGlobalLoading(true);
    const res = await getPlanificadores({ flota: original.codigo });
    const lastPlanificadorData = res?.data?.data; // 'cause is ordered by date
    //return;

    if (!lastPlanificadorData || res.data.count === 0) {
      setAlert(
        true,
        "No hay planificadores para esta flota",
        AlertSeverityEnum.error
      );
      setIsGlobalLoading(false);
      return;
    }
    setIsGlobalLoading(false);
    setSelectedFlota(lastPlanificadorData.at(0)?.flota_data!);
    navigate(`${returnUrlPlanificadoresPage}/calendario/${original.id_flota}`);
  };

  ///* columns
  const { columnsPlanificadorView } = useTableColumnsFlotas({
    enableStateSwitch: false,
  });

  return (
    <SingleTableBoxScene title="Flotas">
      <GeneralTable<Flota>
        columns={columnsPlanificadorView}
        data={flotasPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={flotasPagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        enableSorting={false}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableGlobalFilter={false}
        ///* Actions
        enableEditing={true}
        canEdit={false}
        showCustomActionBtnSpace={true}
        enableColumnActions={true}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}
        customActionBtnSpace={(value) => {
          return (
            <Grid item>
              <Tooltip title={"Ver"} placement="top">
                <IconButton onClick={() => onView(value)}>
                  <Visibility />
                </IconButton>
              </Tooltip>
            </Grid>
          );
        }}
      />
    </SingleTableBoxScene>
  );
};

export default PlanificadoresPageView;
